import { Routes } from '@angular/router';
import { LoginGuard } from 'src/shared/guards/login.guard';
import { IntegratorApiService } from './services/integrator-api.service';
import { JoiiSessionsDataService } from './services/joii-sessions.data.service';

export const JoiiSessionsRoutes: Routes = [
  {
    path: 'joii-sessions',
    canActivate: [LoginGuard],
    providers: [JoiiSessionsDataService, IntegratorApiService],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/home/joii-sessions-home.component').then((m) => m.JoiiSessionsHomeComponent),
      },
      {
        path: 'start',
        loadComponent: () =>
          import('./pages/joii-sessions/joii-sessions.component').then((m) => m.JoiiSessionsComponent),
      },
      {
        path: 'test-api',
        loadComponent: () => import('./pages/test-api/test-api.component').then((m) => m.TestApiComponent),
      },
      {
        path: 'test-linking',
        loadComponent: () => import('./pages/test-linking/test-linking.component').then((m) => m.TestLinkingComponent),
      },
    ],
  },
];
